'use client';

import React, { FC, PropsWithChildren, useState } from 'react';
import { CatList } from '@blocks-react/components/List';
import { CatButton } from '@blocks-react/components/Button';
import { ListMenuItem } from './list-menu-item';
import { ListMenuType } from './list-menu-item/ListMenuItemType';
import { ListMenuProps, getListMenuProps } from './types';
import { v4 as uuidv4 } from 'uuid';

export const ListMenu: FC<PropsWithChildren<ListMenuProps>> = ({
  headingSlot,
  headingProps,
  handleItemClick,
  listItems,
  buttonViewLessText,
  buttonViewMoreText,
  defaultItemsCount = 10,
  type = ListMenuType.LABEL,
  itemClassName
}) => {
  const [isListOpened, setIsListOpened] = useState(false);
  const listLength = !isListOpened ? defaultItemsCount : listItems.length;
  const buttonText = isListOpened ? buttonViewLessText : buttonViewMoreText;
  const viewButton = listItems?.length > defaultItemsCount;
  const items = viewButton ? listItems.slice(0, listLength) : listItems;

  const getListMenu = ({ items, classNames, name }: getListMenuProps) => {
    return (
      <React.Fragment key={`list-wrapper-${uuidv4()}`}>
        {name && <h2 className={classNames?.className}>{name}</h2>}
        <CatList data-testid="list-menu">
          {items?.map((item) => {
            if (item.values) {
              const className = {
                className: 'm-0 mt-1 text-black cat-u-theme-typography-label-sm'
              };
              return getListMenu({
                items: item.values,
                classNames: className,
                name: item.name
              });
            }
            return (
              <ListMenuItem
                key={item.id}
                type={type}
                item={item}
                handleItemClick={handleItemClick}
                className={itemClassName}
              />
            );
          })}
        </CatList>
      </React.Fragment>
    );
  };

  return (
    <>
      {getListMenu({ items, classNames: headingProps, name: headingSlot })}
      {viewButton && (
        <CatButton
          onClick={() => setIsListOpened(!isListOpened)}
          variant="ghost"
        >
          {buttonText}
        </CatButton>
      )}
    </>
  );
};
